import { render, staticRenderFns } from "./team_score.vue?vue&type=template&id=e716f506&"
import script from "./team_score.vue?vue&type=script&lang=js&"
export * from "./team_score.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports